/** Decode packed city data without allocating a per-byte iterator on supported engines. */
export function decodeBase64(text: string): Uint8Array {
  const bytes = Uint8Array as typeof Uint8Array & {
    fromBase64?: (text: string) => Uint8Array;
  };
  if (typeof bytes.fromBase64 === 'function') return bytes.fromBase64(text);
  const binary = atob(text);
  const decoded = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) decoded[i] = binary.charCodeAt(i);
  return decoded;
}
